<template>
    <div class="space-y-6">
        <div
            data-el-grid
            class="wall-grid text-black"
            :style="{
                'grid-template-columns': `repeat(auto-fill, minmax(${wall.width}px, 1fr))`,
            }"
        >
            <ReviewCard
                v-for="testimonial in limitedTestimonials"
                :key="testimonial.id"
                :wall="wall"
                :testimonial="testimonial"
            />
        </div>
        <div class="flex justify-center" v-if="showMore">
            <button
                @click="toggleExpanded"
                :style="{
                    borderColor: wall.borderColor,
                    color: wall.titleColor,
                    'border-radius': wall.borderRadius + 'px',
                }"
                type="button"
                class="border ct-btn-sm opacity-90 hover:opacity-100"
            >
                <span> {{ expanded ? $t("r_love.show_less") : $t("r_love.show_more") }} </span>
            </button>
        </div>
    </div>
</template>

<script>
import ReviewCard from "./ReviewCard.vue";

export default {
    name: "Board",
    props: {
        wall: Object,
    },
    emits: ["updateIframe"],
    data() {
        return {
            expanded: false,
        };
    },
    computed: {
        notHidedTestimonials() {
            return this.wall.testimonials.filter((x) => !x.hide && !x._deleted && x.isPublished);
        },
        limitedTestimonials() {
            if (this.wall.maxTestimonials && !this.expanded) {
                return this.notHidedTestimonials.slice(0, this.wall.maxTestimonials);
            }
            return this.notHidedTestimonials;
        },
        showMore() {
            const maxTestimonials = this.wall.maxTestimonials;
            return maxTestimonials ? this.notHidedTestimonials.length > maxTestimonials : false;
        },
    },
    components: {
        ReviewCard,
    },
    methods: {
        toggleExpanded() {
            this.expanded = !this.expanded;
            this.$nextTick(() => {
                this.$emit("updateIframe");
            });
        },
    },
};
</script>
